const ADS_ID = 'AW-412662118';
const GTAG_SRC = `https://www.googletagmanager.com/gtag/js?id=${ADS_ID}`;

function ensureGoogleTagLoaded() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  const existingScript = document.querySelector<HTMLScriptElement>(
    `script[src="${GTAG_SRC}"]`
  );

  if (existingScript) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = GTAG_SRC;
  script.setAttribute('data-cookie-consent', 'granted');
  document.head.appendChild(script);
}

function ensureDataLayer() {
  if (typeof window === 'undefined') return;

  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).gtag =
    (window as any).gtag ||
    function gtag() {
      (window as any).dataLayer.push(arguments);
    };
}

export function updateConsentGranted() {
  if (typeof window === 'undefined') return;
  ensureDataLayer();
  const gtag = (window as any).gtag;
  if (typeof gtag !== 'function') return;
  (window as any).__adsConsentGranted = true;

  ensureGoogleTagLoaded();

  gtag('consent', 'update', {
    ad_storage: 'granted',
    ad_user_data: 'granted',
    ad_personalization: 'denied',
    analytics_storage: 'denied'
  });

  gtag('js', new Date());

  gtag('config', ADS_ID, {
    anonymize_ip: true,
    allow_google_signals: false
  });
}

export function updateConsentDenied() {
  if (typeof window === 'undefined') return;
  ensureDataLayer();
  const gtag = (window as any).gtag;
  if (typeof gtag !== 'function') return;
  (window as any).__adsConsentGranted = false;

  gtag('consent', 'update', {
    ad_storage: 'denied',
    analytics_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied'
  });
}

export function trackCallClick() {
  if (typeof window === 'undefined') return;
  if (!(window as any).__adsConsentGranted) return;
  const gtag = (window as any).gtag;
  if (typeof gtag !== 'function') return;

  gtag('event', 'conversion', {
    send_to: 'AW-412662118/S_BoCPezrIwcEOby4sQB'
  });
}
